// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C9wu","col":"styles_col__2b3Jh"};